import data from '@/data/data.json'; // Adjust the path if necessary
import tabledata from '@/data/lists.json'; // Adjust the path if necessary
import env_vars from '@/data/env_vars.json'; // Adjust the path if necessary


export const getSoftwareVersion = () => {
    return env_vars?.VERSION || ''
}

export function fetchFormData() {
    return data
}

export function fetchPdfData() {
    return tabledata?.pdf?.structure || {};
}

export function fetchTableData() {
    return tabledata
}

export function fetchSidebarData() {
    return tabledata?.sidebar?.items || [];
}

export function fetchTablePageData() {
    return tabledata?.tables?.list || [];
}

